import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

export const ClinkerClassificationRow = ({material}: {material: Material}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.type}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.grade}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.sulphateResistance}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.alkaliContent}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.lowHeat}</Typography>
    </TableCell>
  </>
)
